import { render, staticRenderFns } from "./Providers.vue?vue&type=template&id=1ca4a970&scoped=true&"
import script from "./Providers.vue?vue&type=script&lang=js&"
export * from "./Providers.vue?vue&type=script&lang=js&"
import style0 from "./Providers.vue?vue&type=style&index=0&id=1ca4a970&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca4a970",
  null
  
)

export default component.exports